import { render, staticRenderFns } from "./ExternalWalletPage.vue?vue&type=template&id=1cb1fc20&"
import script from "./ExternalWalletPage.vue?vue&type=script&lang=ts&"
export * from "./ExternalWalletPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports